<script setup lang="ts">
const route = useRoute()
</script>

<template>
  <main class="flex flex-col gap-2 p-4">
    <div>pages/index.vue:</div>
    <pre>{{ route?.params }}</pre>
  </main>
</template>
